var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag",class:{
              'tag_btn': _vm.btn
          },style:({
              'padding-left': _vm.padding+'px',
              'padding-right': _vm.padding+'px',
              'background-color': _vm.getColor,
              'border-color': _vm.getBorderColor
          }),on:{"click":function($event){return _vm.click()}}},[_c('div',{staticClass:"tag__content",class:{
      'tag__content_color-mix': this.colorMix
    },style:({
      'color': _vm.getTextColor,
    })},[_vm._v(_vm._s(_vm.label)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }